<template>
  <el-main>
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">资讯</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/news', query: {id: news.column.id}}" v-if="news.column">{{
            news.column.title
          }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ news.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <div slot="header" class="header">
          <div class="news-title">{{ news.title }}</div>
          <div class="news-info">
            <div>作者：{{ news.author }}</div>
            <div v-if="news.source">来源：{{ news.source }}</div>
            <div>阅读了：{{ news.click }}</div>
            <div>发布时间：{{ news.created_at }}</div>
          </div>
        </div>
        <div v-html="news.body"></div>
      </el-card>
    </div>
  </el-main>
</template>

<script>
import {request} from "@/utils/request";

export default {
  name: "newDetails",
  head() {
    return {
      title: this.news.title ? this.news.title : '资讯详情'
    }
  },
  data() {
    return {
      id: '',
      news: []
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getNews()
  },
  methods: {
    async getNews() {
      let response = await request('news/' + this.id, {
        method: 'GET',
        params: {
          include: 'column'
        }
      })
      console.log(response)
      this.news = response.data.data
    }
  }
}
</script>

<style scoped>
.header {
  text-align: center;
}

.news-title {
  font-size: 16px;
  font-weight: bold;
}

.news-info {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  color: #999999;
}

.news-info div {
  margin: 0 10px;
}
</style>